/**
 * @file 搜索
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {GET_V1_SEARCH, GET_ASSESSMENT_STATIC} from './ActionTypes';

export function fetchV1Search(dispatch, params) {
    return rcAjax('POST', '/api/v1/search', {}, params, data => {
        dispatch({type: GET_V1_SEARCH, data: data?.data});
    });
}
export function getAssessmentStatic(dispatch, params) {
    let urlStr = params.content;
    for(let i in params) {
        if (i !== 'content') {
            urlStr += '&' + i + '=' + params[i];
        }
    }
    return rcAjax('GET', '/api/v1/assessment/statistics?content=' + urlStr, {}, params, data => {
        dispatch({type: GET_ASSESSMENT_STATIC, data: data?.data});
    });
}